/* eslint-disable */
export default {
  ok: 'OK',
} as const;

// @key: @#@"ok"@#@ @source: @#@"OK"@#@
